import React from 'react';
import styled from 'styled-components';
import { Border, Breakpoints, Color, Grid, Type } from '../../../app/StyleGuide';
import { TransparentButton } from '../../../components/Buttons';
import windowService from '../../../services/windowService';
import { AgeCategory, BrandCode } from '../../curriculum';
import { AdvancePlanningSection } from '../models/advancePlanning';

type OverviewEventsSectionProps = {
  brandCode: BrandCode;
  ageCategory: AgeCategory;
  curriculumId: string;
  events: AdvancePlanningSection[];
  image: string;
};

const Container = styled.div`
  display: grid;
  grid-template-columns: 120px auto;
  align-items: center;
  gap: ${Grid._4};

  h5 {
    margin: 0;
  }

  img {
    width: 100%;
    height: auto;
    border-radius: ${Border.radius};
  }

  button {
    font-size: ${Type.Scale._1};
    padding: 0;
    color: ${Color.Blue._50};
  }

  @media (min-width: ${Breakpoints.screen_lg}) {
    gap: ${Grid._6};
  }
`;

const ListItems = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${Grid._4};
  padding: 0;
  list-style: none;

  @media (min-width: ${Breakpoints.screen_lg}) {
    gap: ${Grid._6};
  }
`;

export const OverviewEventsSection = ({
  brandCode,
  ageCategory,
  curriculumId,
  events,
  image,
}: OverviewEventsSectionProps) => {
  const redirectToAdvancePlanning = (materialId: string) => {
    windowService.redirectTo(
      `/manage-bible-study/advance-planning/${brandCode}/${ageCategory}/${curriculumId}?materialId=${materialId}`
    );
  };

  return (
    <Container>
      <img src={image} />
      <ListItems>
        {events.map(item => (
          <li key={item.id}>
            <h5>{item.header}</h5>
            <TransparentButton onClick={() => redirectToAdvancePlanning(item.id)}>
              View Event Resources
            </TransparentButton>
          </li>
        ))}
      </ListItems>
    </Container>
  );
};
